<div class="webp-image-container" [ngClass]="{'has-blurhash': blurhash}">
  <canvas
    *ngIf="blurhash"
    #canvas
    class="blurhash-placeholder"
    [class.hidden]="imageLoaded"
  ></canvas>
  <picture>
    <source [srcset]="src | webpUrl" type="image/webp">
    <img
      [src]="src"
      [alt]="alt"
      [title]="title"
      [ngStyle]="imgStyle"
      [ngClass]="imgClass"
      [class.loaded]="imageLoaded && blurhash"
      (load)="onImageLoad()"
      [attr.loading]="lazy ? 'lazy' : null">
  </picture>
</div>
